import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  Grid, FormControlLabel, Switch, IconButton, makeStyles, Paper, Slider, Toolbar, Tooltip, Typography,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SettingsIcon from '@material-ui/icons/Settings';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Map from '../map/Map';
import ReplayPathMap from '../map/ReplayPathMap';
import { formatPosition } from '../common/formatter';
import ReportFilter from './ReportFilter';
import { useTranslation } from '../LocalizationProvider';
import SelectField from '../form/SelectField';
import { api_call, console_log, curl_raw_post, getSpeedWithUnit, isGpsMT2VProtocolDevice, isMobile, returnMobileApp, safeGoBack } from '../helpers/untils';
import PaypalCreditLogsModal from '../settings/PaypalCreditLogsModal';
import { ButtonBase, Stack } from '@mui/material';
import { API_BASE_URL, DEVICE_TYPE, MACHINE_ENVIRONMENT } from '../config/constant';
import ReplayAccPathMap from '../map/ReplayAccPathMap';
import ReplayPositionsMap from '../map/ReplayPositionsMap';
import ReplayStopAccDotMap from '../map/ReplayStopAccDotMap';
import TripTimelineModal from '../settings/TripTimelineModal';
import { checkLngLatIsValid } from '../helpers/misc';

import { devicesActions, sessionActions, layoutActions } from '../store';
import usePersistedState from '../common/usePersistedState';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  title: {
    ...theme.typography.title,
  },
  sidebar: {
    position: 'absolute',
    left: 0,
    top: 0,
    margin: theme.spacing(1.5),
    width: '720px', // theme.dimensions.drawerWidthDesktop,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
    },
  },
  formControlLabel: {
    height: '100%',
    width: '100%',
    paddingRight: theme.spacing(1),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  reportFilterContainer: {
    flex: 1,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
    },
  },
  sliderContainer: {
    padding: theme.spacing(2),
  },
}));

const TimeLabel = ({ children, open, value }) => (
  <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
    {children}
  </Tooltip>
);

const TemporaryReplayPage = () => {
  const t = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const timerRef = useRef();
  const { shareUrl } = useParams();
  //console_log("device id::::", id)
  const [reservationId, setReservationId] = usePersistedState('tripReservationId', "");

  const [positions, setPositions] = useState([]);
  const [index, setIndex] = useState(0);
  const [accVal, setAccVal] = useState(2)
  const [showStopSign, setShowStopSign] = useState(false)
  const [selectedDeviceId, setSelectedDeviceId] = useState();
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [expanded, setExpanded] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [autoPlay, setAutoPlay] = useState(true);
  const [device, setDevice] = useState({});
  const [currentLink, setCurrentLink] = useState();

  const loadLinkDevice = async () => {
    const response = await api_call(`/api/temporary/device?shareUrl=${shareUrl}&reservationId=${reservationId}&withLink=1`);
    if (response.ok) {
      const responseData = await response.json();
      const device = responseData['device'];
      dispatch(devicesActions.refresh([device]));
      dispatch(devicesActions.select({ id: device.id }));
      setDevice(device);

      const link = responseData['link'];
      setCurrentLink(link);
    }
  }

  useEffect(() => {
    if (shareUrl) {
      loadLinkDevice();
    }
  }, [shareUrl]);


  useEffect(() => {
    if (isPlaying && positions.length > 0) {
      let interval;
      switch (playbackSpeed) {
        case 5:
          interval = 200;
          break;
        case 10:
          interval = 100;
          break;
        case 1:
        default:
          interval = 1000;
          break;
      }
      timerRef.current = setInterval(() => {
        setIndex((index) => index + 1);
      }, interval);
    } else {
      clearInterval(timerRef.current);
    }

    return () => clearInterval(timerRef.current);
  }, [isPlaying, positions]);

  useEffect(() => {
    setShowStopSign(false)
    if (index && index >= (positions.length - 1)) {
      clearInterval(timerRef.current);
      setIsPlaying(false);
    }
    if (accVal == 1 && positions[index]?.acc == 0) {
      setShowStopSign(true)
    }
    setAccVal(positions[index]?.acc)
  }, [index]);

  const submitParams = useRef(null)

  const handleSubmit = async (deviceId, from, to, _, headers) => {
    submitParams.current = {
      shareUrl: shareUrl,
      // from: from,
      // to: to
    }

    setSelectedDeviceId(deviceId);
    let query = new URLSearchParams({ shareUrl, reservationId });
    const response = await api_call(`/api/temporary/positions?${query.toString()}`, { headers });
    if (response.ok) {
      const positions_data = await response.json();
      const valid_positions = positions_data.filter((item) => checkLngLatIsValid(item))
      setIndex(0);
      setPositions(valid_positions);
      setExpanded(false);
    }
  }

  /////////////////////////////////////////start paypal credit logs modal//////////////////////////////////////////
  const [chargeRequiredNum, setChargeRequiredNum] = useState(0)
  const showPaypalCreditLogsPage = (item, chargeRequired = 0) => {
    //dispatch(layoutActions.closeDeviceListMenu());
    setDeviceItem(item)
    setPaypalCreditModalOpen(true)
    setChargeRequiredNum(chargeRequired)
  }
  const [paypalCreditModalOpen, setPaypalCreditModalOpen] = useState(false);
  const [deviceItem, setDeviceItem] = useState({});
  /////////////////////////////////////////end paypal credit logs modal////////////////////////////////////////////////////

  /////////////////////////////////////////start trips timeline modal//////////////////////////////////////////
  const [tripTimelineModalOpen, setTripTimelineModalOpen] = useState(false);
  const onClickTrips = () => {
    if (selectedDeviceId) {
      setTripTimelineModalOpen(true);
    } else {
      window.alert(`Please select a device`);
    }
  }
  /////////////////////////////////////////end trips timeline modal////////////////////////////////////////////////////

  const exportCsv = () => {
    let query = new URLSearchParams({ shareUrl, reservationId });
    const exportUrl = `${API_BASE_URL}/api/temporary/export-positions?${query.toString()}`
    console_log(`exportUrl::::`, exportUrl);
    curl_raw_post(exportUrl, {}, 'post'); //window.location.href = exportUrl
  }

  const onClickNav = () => {
    if (positions.length > 0) {
      const position = positions[index]
      if (position) {
        const url = `https://www.google.com/maps/dir/your+location/${position.latitude},${position.longitude}/@${position.latitude},${position.longitude},17z`
        window.open(url, '_blank');
      }
    }
  }

  return (
    <div className={classes.root}>
      <Map>
        <ReplayPathMap
          positions={positions}
        />
        {
          index < positions.length && (
            <ReplayPositionsMap
              showStopSign={showStopSign}
              positions={[positions[index]]}
              pageType="replay"
              showPaypalCreditLogsPage={showPaypalCreditLogsPage}
              enablePopup={false}
              temporaryPage={true}
            />
          )
        }
        <ReplayAccPathMap
          device={device}
          positions={positions}
        />
        <ReplayStopAccDotMap
          device={device}
          positions={positions}
        />
      </Map>
      <div className={classes.sidebar}>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Paper elevation={3} square>
              <Toolbar disableGutters>
                <Grid container alignItems="center">
                  <Grid item>
                    <IconButton onClick={
                      () => {
                        console_log(`expanded::::`, expanded);
                        if (!expanded) {
                          setExpanded(true);
                        }
                        else {
                          returnMobileApp(history);
                        }
                      }
                    }
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs>
                    <Typography className={classes.replay} color="primary">
                      {t('reportReplay')}
                    </Typography>
                  </Grid>
                  {!expanded && (
                    <Grid item>
                      <IconButton onClick={() => setExpanded(true)}>
                        <SettingsIcon />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Toolbar>
            </Paper>
          </Grid>
          <Grid item>
            {!expanded ? (
              <Paper className={classes.sliderContainer}>
                <Grid container direction="column" alignItems="center" spacing={1}>
                  {
                    (positions.length > 0) ? (
                      <>
                        <Grid item container justifyContent="space-between" alignItems="center">
                          <Grid>
                            <IconButton size="small" onClick={() => {
                              if (index < (positions.length - 1)) setIsPlaying(!isPlaying)
                            }}>
                              {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                          </Grid>
                          <Grid>
                            <span className={classes.title}>{device?.name}</span>
                          </Grid>
                          <Grid>
                            <ButtonBase onClick={() => onClickNav()} disableRipple={true}>
                              <span style={{ cursor: 'pointer', color: '#1366ff' }}>NAV</span>
                            </ButtonBase>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} style={{ width: '100%' }}>
                          <Stack direction={`row`} alignItems={`center`} justifyContent={`flex-start`} style={{ width: '100%' }} spacing={2}>
                            <Stack direction={`column`} justifyContent={`center`} alignItems={`center`} style={{ width: '100%', flex: 1 }} spacing={1}>
                              <Slider
                                max={positions.length - 1}
                                step={null}
                                marks={positions.map((_, index) => ({ value: index }))}
                                value={index}
                                onChange={(_, index) => setIndex(index)}
                                valueLabelDisplay="auto"
                                valueLabelFormat={(i) => (i < positions.length ? formatPosition(positions[i], 'deviceTime') : '')}
                                ValueLabelComponent={TimeLabel}
                              />
                            </Stack>
                            <Stack direction={`column`} justifyContent={`center`} alignItems={`center`} spacing={1}>
                              <IconButton size="small" onClick={() => exportCsv()} title="Export">
                                <FileDownloadIcon />
                              </IconButton>
                            </Stack>
                          </Stack>
                        </Grid>

                        <Grid item container justifyContent="space-between" alignItems="center">
                          <Grid>{`${index}/${positions.length - 1} (${playbackSpeed}X)`}</Grid>
                          <Grid>
                            <Stack direction={`row`} justifyContent={`flex-end`}>
                              {formatPosition(positions[index], 'deviceTime')}
                            </Stack>
                          </Grid>
                        </Grid>

                        <Grid item container justifyContent="space-between" alignItems="center">
                          <Grid item>
                            <div style={{ textAlign: 'left' }}>
                              {
                                (positions[index]?.speed) ? (
                                  <>{getSpeedWithUnit(positions[index].speed, device?.distance_unit)}</>
                                ) : (
                                  <>{getSpeedWithUnit(0, device?.distance_unit)}</>
                                )
                              }
                            </div>
                          </Grid>
                          <Grid item>
                            {
                              (device?.deviceType === DEVICE_TYPE.TESLA || device?.deviceType === DEVICE_TYPE.SMARTCAR) ? (
                                <div style={{ textAlign: 'center' }}>
                                  {
                                    (positions[index]?.ac_charging_power > 0 || positions[index]?.dc_charging_power > 0) ? (
                                      <>{"Charging: " + Math.max(positions[index]?.ac_charging_power, positions[index]?.dc_charging_power) + "Kw"}</>
                                    ) : (
                                      <></>
                                    )
                                  }
                                </div>
                              ) : (
                                <div style={{ textAlign: 'center' }}>
                                  {
                                    (positions[index]?.signal) ? (
                                      <>{"Signal: " + ((Number(positions[index].signal) / 31) * 100).toFixed(0) + "%"}</>
                                    ) : (
                                      <>{"Signal: 0%"}</>
                                    )
                                  }
                                </div>
                              )
                            }
                          </Grid>
                          <>
                            {
                              (device?.deviceType === DEVICE_TYPE.TESLA || device?.deviceType === DEVICE_TYPE.SMARTCAR) ? (
                                <Grid item>
                                  <div style={{ textAlign: 'right' }}>
                                    {
                                      (positions[index]?.mt2v_dc_volt) ? (
                                        <>{`Bat: ${Number(positions[index]?.mt2v_dc_volt)} %`}</>
                                      ) : (
                                        <>{"Bat: 0 %"}</>
                                      )
                                    }
                                  </div>
                                </Grid>
                              ) : (isGpsMT2VProtocolDevice(device?.uniqueId)) ? (
                                <Grid item>
                                  <div style={{ textAlign: 'right' }}>
                                    {
                                      (positions[index]?.mt2v_dc_volt) ? (
                                        <>{`Bat: ${positions[index]?.mt2v_dc_volt} V`}</>
                                      ) : (
                                        <>{"Bat: 0 V"}</>
                                      )
                                    }
                                  </div>
                                </Grid>
                              ) : (
                                <></>
                              )
                            }
                          </>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item className='mt-3'>&#8211; No playback data found &#8211;</Grid>
                      </>
                    )
                  }
                </Grid>
              </Paper>
            ) : (
              <Paper elevation={3} className={classes.reportFilterContainer} square>
                <ReportFilter
                  handleSubmit={handleSubmit}
                  fullScreen
                  showOnly
                  selectedDeviceId={device?.id}
                  setSelectedDeviceId={setSelectedDeviceId}
                  temporaryPage={true}
                  currentLink={currentLink}
                >
                  <Grid item xs={6}>
                    <Stack direction={`row`} alignItems={`center`} justifyContent={`space-between`} spacing={2}>
                      <div></div>

                      <SelectField
                        margin="normal"
                        value={playbackSpeed + "X"}
                        emptyValue={null}
                        onChange={(event) => setPlaybackSpeed(() => {
                          switch (event.target.value) {
                            case '5X':
                              return 5;
                            case '10X':
                              return 10;
                            case '1X':
                            default:
                              return 1;
                          }
                        })}
                        data={[{ id: '1X', name: '1X' }, { id: '5X', name: '5X' }, { id: '10X', name: '10X' }]}
                        label='Playback Speed'
                        variant="filled"
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      classes={{ root: classes.formControlLabel }}
                      control={(
                        <Switch
                          checked={autoPlay}
                          onChange={(e) => setAutoPlay(e.target.checked)}
                          color="primary"
                          edge="start"
                        />
                      )}
                      label="AutoPlay"
                      labelPlacement="start"
                    />
                  </Grid>
                </ReportFilter>
              </Paper>
            )}
          </Grid>
        </Grid>
      </div>

      <>
        <PaypalCreditLogsModal
          open={paypalCreditModalOpen}
          setOpen={setPaypalCreditModalOpen}
          chargeRequiredNum={chargeRequiredNum}
          item={deviceItem}
          setItem={setDeviceItem}
        />

        <TripTimelineModal
          open={tripTimelineModalOpen}
          setOpen={setTripTimelineModalOpen}
          deviceId={device?.id}
        />
      </>
    </div>
  );
};

export default TemporaryReplayPage;
